<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Kode Agen</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.CustCode"
                @keyup.13.native="lkuItemShow=true"
                :state="!$v.model.customer_id.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn
                  text="Button"
                  id="btnKoranCust"
                  @click="lkuKoranCustShow=true"
                  :disabled="disabledInput"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Nama Agen</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.CustName" readonly></b-form-input>
            </b-input-group>
            <b-input-group label-cols-md="2">
              <b-input-group-prepend>
                <label>Alamat Penagihan</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.biliingAddr1" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label></label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.biliingAddr2" readonly></b-form-input>
            </b-input-group>
            <!-- <b-input-group :label-cols-md="2" label-align-xl="right" label="Kota / Provinsi">
              <b-row>
                <b-col class="pr-1" cols="8">
                  <b-form-input v-model="customer.City" readonly></b-form-input>
                </b-col>
                <b-col class="pl-1" cols="4">
                  <b-input-group label-cols="4" label="Kode Post">
                    <b-form-input v-model="customer.billing_zipcode" readonly></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-input-group>-->
            <b-input-group>
              <b-input-group-prepend>
                <label>Telephone</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.PhoneNo" readonly></b-form-input>
              <b-input-group-prepend>
                <label class="text-center">Fax</label>
              </b-input-group-prepend>
              <b-form-input v-model="customer.FaxNo" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Sales Executive</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.salesae_name"
                @keyup.13.native="lkuKoranSalesShow=true"
                :state="!$v.model.salesae_id.$error"
                placeholder="Pilih Sales Executive"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <span class="pl-2 pt-2">Kolektor</span>
              </b-input-group-append>
              <b-form-input
                readonly
                v-model="model.collector_name"
                @keyup.13.native="lkuKoranColectorShow=true"
                placeholder="Pilih Kolektor"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranColectorShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <label>Alamat Pengiriman</label>
              </b-input-group-prepend>
              <b-form-textarea v-model="model.address" :state="!$v.model.address.$error" rows="2" max-rows="5"></b-form-textarea>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Titik Drop</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.titikdrop"
                placeholder="Titik drop"
                :state="!$v.model.titikdrop.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranAgenShow=true" v-b-tooltip.hover title="Drop ke Agen (Kirim via Agen)">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>

            </b-input-group>
            <b-input-group >
              <b-input-group-prepend>
                <label>Kota Layanan</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.kota_name"
                @keyup.13.native="lkuKoranKotaShow=true"
                :state="!$v.model.kota_id.$error"
                placeholder="Pilih Kota/Area"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranKotaShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              <b-input-group-append>
                <span class="pl-2 pt-2">Rute</span>
              </b-input-group-append>
              <b-form-input
                readonly
                v-model="model.jurusan_name"
                @keyup.13.native="lkuKoranJurusanShow=true"
                :state="!$v.model.jurusan_id.$error"
                placeholder="Pilih Jurusan"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group>
              <b-input-group-prepend>
                <label>Titip Kirim ke</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.namaAgentDititip"
                @keyup.13.native="lkuKoranAgenShow=true"
                placeholder="Pilih Agent"
                ref="inputtitipanagen"
                :state="stateTititpKirimKe"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranAgen" @click="lkuKoranAgenShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
                <b-btn
                  text="Button"
                  id="btnKoranAgenCleat"
                  @click="model.namaAgentDititip=null"
                >
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
              <b-form-invalid-feedback class="text-right">{{errMsgTitipKirim}}</b-form-invalid-feedback>
            </b-input-group> -->

          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Invoice No.</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.invoiceno" placeholder="Invoice No."></b-form-input>
              <b-input-group-prepend is-text>
                <b>Tanggal Invoice</b>
              </b-input-group-prepend>
              <b-form-input v-model="model.invdate" type="date"></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Uraian</label>
              </b-input-group-prepend>
              <b-form-textarea v-model="model.uraian" placeholder="Masukkan uraian" rows="2" max-rows="5"></b-form-textarea>
            </b-input-group>
            <b-row>
              <b-col lg="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jenis Kiriman</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="model.kiriman_code"
                    :options="jeniskiriman"
                    class="mb-1"
                    :state="!$v.model.kiriman_code.$error"
                    :plain="true"
                  >
                    <template v-slot:first>
                      <option :value="null" disabled>-- Pilih jenis kiriman --</option>
                    </template>
                  </b-form-select>
                </b-input-group>
              </b-col> 
            </b-row>
            <!-- <b-row>
              <b-col lg="6">
              </b-col>
              <b-col cols="6">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="p-2">Pembayaran</span>
                    </b-input-group-prepend>
                    <b-form-radio-group id="radio-group-2" v-model="model.isprabayar" class="mt-2">
                      <b-form-radio value="1">Pra Bayar</b-form-radio>
                      <b-form-radio value="0">Pasca Bayar</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col cols="6">
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Tgl. Awal Kirim</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.startdate" type="date"></b-form-input>
                  </b-input-group>

                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jumlah Hari</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.jumlahHari" type="number"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kiriman per Hari</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right"
                    separator=","
                    id="hrg_agen_ecer"
                    v-model="model.kirimharian"
                    :state="!$v.model.kirimharian.$error"
                  ></my-number>
                  <b-form-invalid-feedback class="text-right">Pengiriman harus lebih dari 0.</b-form-invalid-feedback>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Total Eksemplar</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right"
                    separator=","
                    id="hrg_agen_konsi"
                    :value="tot_eksemplar"
                    :state="!$v.model.tot_eksemplar.$error"
                    disabled
                  ></my-number>
                </b-input-group>
              </b-col>
              <b-col cols="6">
            <b-input-group>
                  <b-input-group-prepend>
                    <label>Est. Tgl Selesai</label>
                  </b-input-group-prepend>
                    <b-form-input v-model="model.enddate" type="date"></b-form-input>
            </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Subtotal Harga</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right"
                    separator=","
                    id="subtot_harga"
                    v-model="subtot_harga"
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label class="font-weight-bold">Potongan Harga</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right"
                    separator=","
                    id="hrg_agen_konsi"
                    v-model="model.potongan"
                    :state="!$v.model.potongan.$error"
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label class="font-weight-bold">Total Harga</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right font-weight-bold"
                    separator=","
                    id="hrg_agen_konsi"
                    v-model="model.tot_harga"
                    :state="!$v.model.tot_harga.$error"
                    disabled
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label class="font-weight-bold">Harga / Eksemplar</label>
                  </b-input-group-prepend>
                  <my-number
                    class="form-control text-right"
                    separator=","
                    id="hrg_agen_konsi"
                    :value="unitPrice"
                    disabled
                  ></my-number>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      <hr />
      <br />
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>

    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List of Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectSalese" crudfilter="koran=1"></lku-salesae>
    </b-modal>

    <b-modal
      v-model="lkuKoranSalesTeleShow"
      size="lg"
      :hide-footer="true"
      title="List of Sales Tele"
      :centered="true"
    >
      <lku-salesae @click="onSelectSalesTele" crudfilter="koran=1"></lku-salesae>
    </b-modal>

    <b-modal
      v-model="lkuKoranColectorShow"
      size="lg"
      :hide-footer="true"
      title="List of Collector"
      :centered="true"
    >
      <lku-collector @click="onSelectCollector"></lku-collector>
    </b-modal>

    <b-modal
      v-model="lkuKoranJurusanShow"
      size="lg"
      :hide-footer="true"
      title="List of Jurusan/Ekspedisi"
      :centered="true"
    >
      <lku-koran-jurusan @click="onSelectKoranJurusan"></lku-koran-jurusan>
    </b-modal>

    <b-modal
      v-model="lkuKoranKotaShow" size="lg"
      :hide-footer="true"
      title="List of Kota Layanan"
      :centered="true"
    >
      <lku-koran-kota @click="onSelectKoranKota"></lku-koran-kota>
    </b-modal>

    <b-modal
      v-model="lkuKoranAgenShow"
      size="lg"
      :hide-footer="true"
      title="Kirim via Agen (drop ke Agen)"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranAgen" :customer_group="koranagngroup"></lku-koran-cust>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import accounting from "accounting-js";
import {
  required,
  minValue,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";

import toastr from "mini-toastr";
import myNumber from "../../components/my-number";
import vNumber from "vue-numeric";
import crud from "../../apis/crud";
import customer from "../../apis/customer";
import koran_pesanan from "../../apis/koran_pesanan_periode";
import lkuKoranCust from "../lookup/lkuKoranCust";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";
import lkuKoranJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranKota from "../lookup/lkuKoranKota";
import drpDwn from "../../data/dropdown";
import moment from "moment";
toastr.init();

export default {
  components: {
    Loading,
    lkuKoranCust,
    lkuSalesae,
    lkuCollector,
    lkuKoranJurusan,
    lkuKoranKota,
    vNumber,
    myNumber
  },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      address: { required },
      CustCode: { required },
      jurusan_id: { required },
      kota_id: { required },
      titikdrop: { required },
      salesae_id: { required },
      kiriman_code: { required },
      startdate: { required },
      enddate: { required },
      jumlahHari: { required },
      kirimharian: { required, minValue: minValue(1) },
      tot_eksemplar: { required },
      potongan: { required },
      tot_harga: { required }
    }
  },
  data() {
    return {
      isLoading: false,
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranSalesTeleShow: false,
      lkuKoranColectorShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKotaShow: false,
      lkuKoranAgenShow: false,
      stateTititpKirimKe: true,
      errMsgTitipKirim: null,
      disabledInput: false,
      model: {
        customer_id: null,
        address: null,
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        sales_tele: null,
        kota_id: null,
        collector_id: null,
        jumlahHari: 1,
        startdate: null,
        enddate: null,
        potongan: 0,
        kirimtitipke: null,
        titikdrop: null,
        isprabayar: 1,
        namaAgentDititip:null,
        hrg_langganan_area: 0 // diambil dari harga langganan per area
      },
      subtot_harga: 0,
      customer: {},
      customerGroups: [],
      taxBussinesGroups: [],
      optionActive: drpDwn.YesNo,
      jeniskiriman: [],
      koranjurusan: [],
      jurusanSelected: {
        jurusan_name: null
      },
      salesae: [],
      korankota: [],
      collectors: [],
      koranagngroup: "KORANAGEN",
      startdate: null,
      enddate: null,
      invdate: null,
      numOfHoliday: 0
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    findKota: async function() {
      if (this.model && this.model.kota_id) {
        const obj = {
          tablename: "vwkorankota",
          key: this.model.kota_id
        };
        const kotaDetail = await crud.detail(obj);
        if (kotaDetail.hrg_langganan > 0) {
          this.model.hrg_langganan_area = kotaDetail.hrg_langganan;
        }
        return kotaDetail;
      } else {
        return null;
      }
    },
    findJurusan() {
      return this.model.jurusan_id;
    },
    // jumlahHari() {
    //   if (this.model.startdate && this.model.enddate) {
    //     console.log("jumlah hari");
    //     this.countHoliday();
    //     var a = moment(this.model.enddate);
    //     var b = moment(this.model.startdate);
    //     const diff = a.diff(b, "days") + 1;
    //     return diff - this.numOfHoliday;
    //   } else {
    //     return 0;
    //   }
    // },
    tot_eksemplar() {
      let jumlahHari = this.model.jumlahHari || 1;
      let krmharian = this.model.kirimharian || 0;
      const hrg_langganan = this.model.hrg_langganan || 0;
      const subtot_harga = this.subtot_harga || 0;
      let tot_eksemplar = jumlahHari * krmharian;
      this.model.tot_harga = this.subtot_harga - this.model.potongan || 0;
      this.model.tot_eksemplar = tot_eksemplar || 0;
      return tot_eksemplar;
    },
    unitPrice() {
      return this.model.tot_harga / this.tot_eksemplar || 0;
    }
  },
  watch: {
    findKota: async val => {},
    findJurusan(newval) {
      let find = this.koranJrsList.find(x => x.jurusan_id === newval);
      this.jurusanSelected = find;
    },
    startdate(val) {
      if (val !== null) this.model.startdate = moment(val).format("YYYY-MM-DD");
      else this.model.startdate = null;
    },
    // "model.jumlahHari": function(val) {
    //   if (val !== null) {
    //     this.model.enddate = moment(this.model.startdate).add(val,"d").format("YYYY-MM-DD");
    //   } else {
    //     this.model.enddate = null;
    //   }      
    // },
    invdate(val) {
      if (val !== null) this.model.invdate = moment(val).format("YYYY-MM-DD");
      else this.model.invdate = null;
    }
  },
  created: async function() {
    const [a, b, c, d, e] = await Promise.all([
      crud.list({ tablename: "koranjeniskiriman" }),
      crud.list({ tablename: "vwkoranjurusan", limit: 1000 }),
      crud.list({ tablename: "vwsalesae" }),
      crud.list({ tablename: "vwkorankota", limit: 1000 }),
      crud.list({ tablename: "vwcollector" })
    ]);
    this.jeniskiriman = a.reduce((newArr = [], el, idx) => {
      newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
      return newArr;
    }, []);

    this.koranJrsList = b;
    this.koranjurusan = b.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.jurusan_id,
        text: `${el.jurusan_code} | ${el.jurusan_name}`
      });
      return newArr;
    }, []);

    this.salesae = c.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.salesae_id,
        text: `${el.crewnik} | ${el.crewname}`
      });
      return newArr;
    }, []);

    this.korankota = d.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.kota_id,
        text: `${el.kota_id} | ${el.kota_name}`
      });
      return newArr;
    }, []);

    this.collectors = e.reduce((newArr = [], el, idx) => {
      newArr.push({
        value: el.collector_id,
        text: `${el.crewnik} | ${el.collector_name}`
      });
      return newArr;
    }, []);

    if (this.$route.params.tablekey) {
      this.isLoading = true;
      const detail = await koran_pesanan.detail(this.$route.params);
      console.log("detail", detail[0]);
      this.model = detail[0];
      this.model.address =
        detail[0].DeliveryAddr ||
        `${detail[0].Address1.trim()} ${
          detail[0].Address2 ? detail[0].Address2.trim() : ""
        }. ${detail[0].City} `;
      this.subtot_harga =
        this.model.subtot_harga || detail[0].tot_harga - detail[0].potongan;
      this.startdate = detail[0].startdate
        ? new Date(detail[0].startdate)
        : null;
      this.enddate = detail[0].enddate ? new Date(detail[0].enddate) : null;
      this.invdate = detail[0].invdate ? new Date(detail[0].invdate) : null;
      this.model.jurusan_info = `${detail[0].jurusan_code} | ${detail[0].jurusan_name}`;
      this.customer = detail[0];
      this.customer.biliingAddr1 = `${detail[0].Address1} ${
        detail[0].Address2 ? detail[0].Address2 : ""
      } `;
      this.customer.biliingAddr2 = `${detail[0].City}${
        detail[0].PostCode ? "Kode pos : " + detail[0].billing_zipcode : ""
      }`;

      this.isLoading = false;
      this.disabledInput = true;
    }

    this.$watch('model.startdate', function(newVal) {
        setTimeout(() => {
          if (this.model.enddate) {
            this.model.jumlahHari = moment(this.model.enddate).diff(moment(newVal), 'days') + 1;
          }
        }, 100);
    });   
    this.$watch('model.enddate', function(newVal) {
        setTimeout(() => {
          if (this.model.startdate) {
            this.model.jumlahHari = moment(newVal).diff(moment(this.model.startdate), 'days') +1; 
          }
        }, 100);
    });   

  },
  methods: {
    countHoliday: async function() {
      const customQuery =
        "date=" +
        encodeURIComponent(this.model.startdate) +
        "&date=" +
        encodeURIComponent(this.model.enddate);
      const tblData = {
        sortDesc: "desc",
        tablename: "liburterbit",
        customQuery
      };
      const cntHolyday = await crud.list(tblData);
      this.numOfHoliday = parseInt(cntHolyday.length, 10);
    },
    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    onSelectSalese: async function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.salesae_name = `${_sales.crewname || _sales.salesae_name}`;
      this.lkuKoranSalesShow = false;
    },
    onSelectSalesTele: async function(_sales) {
      this.model.sales_tele = _sales.salesae_id;
      this.model.sales_tele_name = `${_sales.crewname}`;
      this.lkuKoranSalesTeleShow = false;
    },
    onSelectCollector: async function(_collec) {
      this.model.collector_id = _collec.collector_id;
      this.model.collector_name = `${_collec.crewname}`;
      this.lkuKoranColectorShow = false;
    },
    onSelectKoranJurusan: async function(_selected) {
      this.model.jurusan_id = _selected.jurusan_id;
      this.model.jurusan_name = _selected.jurusan_name;
      this.model.jurusan_info =
        _selected.jurusan_code + " | " + _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranKota: async function(_selected) {
      this.model.kota_id = _selected.kota_id;
      this.model.kota_name = _selected.kota_name;
      // this.model.hrg_langganan = _selected.hrg_langganan;
      // this.model.hrg_agen_ecer = _selected.hrg_agen_ecer;
      // this.model.hrg_agen_konsi = _selected.hrg_agen_konsi;
      if (_selected.salesae_id){
         if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = `${_selected.crewname || _selected.salesae_name}`;
         }          
      }
      this.lkuKoranKotaShow = false;
    },
    onSelectKoranCust(_selected) {
      // console.log("_selected", _selected);
      if (
        this.model.kirimtitipke !== null &&
        this.model.kirimtitipke === _selected.customer_id
      ) {
        this.lkuKoranAgenShow = false;
        this.stateTititpKirimKe = false;
        this.errMsgTitipKirim = "Pilih Customer yang berbeda dg Agen untuk dititipkan.";
        this.lkuKoranCustShow = false;
      } else {
        this.customer = _selected;
        this.customer.biliingAddr1 = `${_selected.Address1} ${
          _selected.Address2 ? _selected.Address2 : ""
        } `;
        this.customer.biliingAddr2 = `${_selected.City}${
          _selected.PostCode ? "Kode pos : " + _selected.billing_zipcode : ""
        }`;
        if (_selected.DeliveryAddr) {
          this.model.address = _selected.DeliveryAddr;
        } else {
          this.model.address = `${_selected.Address1} ${
            _selected.Address2 !== null ? _selected.Address2 : ""
              } ${_selected.City}`;
        }

        // this.model.address =
        //   _selected.DeliveryAddr ||
        //   `${this.customer.Address1.trim()} ${
        //     this.customer.Address2 !== null ? this.customer.Address2.trim() : ""
        //   }. ${this.customer.City.trim()} `;
        this.model.customer_id = _selected.customer_id;
        this.model.CustCode = _selected.CustCode;
        
        if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = _selected.salesae_name;
        }
        if (!(this.model.kota_id)) {
          this.model.kota_id = _selected.kota_id;
          this.model.kota_name = _selected.kota_name;
        }
        if (!(this.model.jurusan_id)) {
          this.model.jurusan_id = _selected.jurusan_id;
          this.model.jurusan_name = _selected.jurusan_name;
          this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
        }
        if (!(this.model.titikdrop)) {
          this.model.titikdrop = _selected.titikdrop;
        }


        this.lkuKoranCustShow = false;
        this.stateTititpKirimKe = true;
        this.errMsgTitipKirim = null;
      }
    },
    // onSelectKoranAgen(_selected) {
    //   if (this.model.customer_id === null) {
    //     this.lkuKoranAgenShow = false;
    //     this.stateTititpKirimKe = false;
    //     this.errMsgTitipKirim = "Pilih Customer terlebih dahulu.";
    //     // this.invalidModel;
    //   } else if (
    //     _selected.customer_id &&
    //     this.model.customer_id === _selected.customer_id
    //   ) {
    //     this.lkuKoranAgenShow = false;
    //     this.stateTititpKirimKe = false;
    //     this.errMsgTitipKirim = "Pilih Customer yang berbeda dg Agen untuk dititipkan.";
    //   } else if (_selected && _selected.customer_id) {
    //     this.model.namaAgentDititip = `${_selected.CustName} | ${_selected.CustCode}`;
    //     this.model.kirimtitipke = _selected.customer_id;
    //     this.lkuKoranAgenShow = false;
    //     this.stateTititpKirimKe = true;
    //     this.errMsgTitipKirim = null;
    //   }
    // },
    onSelectKoranAgen(_selected) {
      if (this.model.customer_id === _selected.customer_id) {
            toastr.error("Pilih Customer yang berbeda !.");
      } else {
          this.model.titikdrop = _selected.CustName;
          this.lkuKoranAgenShow = false;
      }
    },
    clearTitipanAgen() {
      this.model.namaAgentDititip = null;
      this.model.kirimtitipke = null;
      this.$refs.inputtitipanagen.setValue("");
    },
    save: async function() {
      console.log("this.model ==>", this.model);
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.model.hrg_langganan = this.unitPrice;
          await koran_pesanan.save(this.model);
          toastr.success("Pesanan berhasil disimpan");
          this.close();
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    close() {
      // if (this.$store.state.prevRoute.name) {
      //   router.push({ name: this.$store.state.prevRoute.name });
      // } else {
      //   router.push({ name: "koran.customer" });
      // }
      router.push({ name: "koran.pesananperiode" });
    }
  }
};
</script>